import styled from 'styled-components';

export const Table = styled.table`
    width: 100%;
    border: solid 1px #ddd;
    border-collapse: collapse;
    border-spacing: 0px;
`;
export const THead = styled.thead``;
export const TH = styled.th`
    padding: 15px 25px;
    font-size: 12px;
    color: #bebfc0;
    font-family: AvenirNext;
    font-style: normal;
    text-transform: uppercase;
    font-weight: normal;
    position: relative;
    &.active {
        &:after {
            content: "";
            border-top: 3px solid #bebfc0;
            border-left: 3px solid transparent;
            border-bottom: 3px solid transparent;
            border-right: 3px solid transparent;
            display: inline-block;
            margin: 0 3px;
        }
        &.up {
            &:after {
                margin-bottom: 3px;
                transform: rotate(180deg);
            }
        }
        span {
            text-decoration: none !important;
        }
    }
    &.pointer {
        cursor: pointer;
        span {
            text-decoration: underline;
        }
    }
`;
export const TBody = styled.tbody``;
export const TR = styled.tr`
    border-top: solid 1px #ddd;
`;
export const TD = styled.td`
    padding: 15px;
    font-size: 12px;
    color: #4a4a4a;
    font-family: "AvenirNext";
    font-weight: 500;
    font-style: normal;
    word-break: initial;
    &.brk {
        word-break: break-all;
    }
`;
